/**
 * Módulos con opt-in POR EMPRESA.
 *
 * No es lo mismo que `MODULE_IDS_REQUIRE_EXPLICIT_GRANT`, aunque desde el panel
 * se parezcan: acá el `hasAccess: true` se exige en la EMPRESA, y el usuario lo
 * hereda. Por eso la misma fila ausente significa cosas distintas según dónde se
 * mire: en la empresa, sin acceso; en el usuario, con acceso.
 *
 * Pintarlos con la regla de siempre —"sin fila, con acceso"— hacía que el panel
 * mostrara como concedidas empresas que el backend estaba bloqueando.
 *
 * Sincronizar con MODULE_IDS_REQUIRE_COMPANY_GRANT de smart_back
 * (helpers/permission-guard.ts) y su espejo en smart_front
 * (hooks/useModulePermissions.js).
 */
export const MODULE_IDS_REQUIRE_COMPANY_GRANT = [
  // Los tres del feature de estructuras maestras: se conceden por separado.
  'estructuras_maestras',
  'estado_de_resultados_gestion',
  'balance_clasificado_gestion',
]

export function isCompanyGrantModule(moduleId) {
  return MODULE_IDS_REQUIRE_COMPANY_GRANT.includes(moduleId)
}

/**
 * @param {object|undefined} existingPerm fila de modulePermissions, si existe
 * @param {boolean} esUsuario true si se está pintando el panel de un usuario
 */
export function defaultCompanyGrantModuleAccess(existingPerm, esUsuario) {
  if (existingPerm?.hasAccess === true) return true
  if (existingPerm?.hasAccess === false) return false
  // Sin fila: la empresa no lo tiene; el usuario sí, porque lo hereda.
  return Boolean(esUsuario)
}
